import { paymentsConfig, createSelectOptionsForCardForm, getCardInfo } from './paymentsUtils';

paymentsConfig.loadSDKScript(20);

export const setInstallments = (form) => {
  const parcelsOption = Array.from(form.querySelectorAll("select#cardInstallments option"));
  let maxParcels = 0;
  if (parcelsOption) {
    maxParcels = parcelsOption[parcelsOption.length - 1]?.value?.split("_")[0];
    maxParcels = parseInt(maxParcels);
  }
  form.querySelector("input#cardNumber")?.addEventListener('blur', () => {
    const { cardNumber } = getCardInfo(form);
    if (!MercadoPago) {
      console.log("Falha ao carregar o script do mercado pago");
      return;
    }
    if (window.TransactionInfo && window.TransactionInfo.total && cardNumber.length >= 6) {
      const amount = window.TransactionInfo.total.replace('.', '').replace(',', '.');
      const mp = new MercadoPago(paymentsConfig.getByGateway(20).sdk_public_key, {
        locale: 'pt-BR',
        advancedFraudPrevention: true
      });
      mp.getInstallments({ amount, bin: cardNumber })
        .then(([installmentsResponse]) => {
          const select = form.querySelector("select#cardInstallments");
          select.innerHTML = "";
          createSelectOptionsForCardForm(select, 0, 0, '');
          for(const { installments, total_amount, recommended_message } of installmentsResponse.payer_costs) {
            if (maxParcels > 0 && installments > maxParcels) break;
            const installmentRate = (total_amount - parseFloat(amount)).toFixed(2);
            createSelectOptionsForCardForm(select, installments, installmentRate, recommended_message);
          }
          const paymentMethodInput = form.querySelector("input#payment_method"); 
          if (paymentMethodInput) {
            paymentMethodInput.value = installmentsResponse.payment_method_id;
          }
        });
    }
  });
}


export const submitForm = (form) => {
  if (!MercadoPago) {
    return Promise.reject("Falha ao carregar o script do mercado pago");
  }
  const { cardholderName, cardNumber, securityCode, cardExpirationMonth, cardExpirationYear } = getCardInfo(form);
  if (
    !cardholderName || !cardNumber || !securityCode || !cardExpirationMonth || !cardExpirationYear
  ) {
    return Promise.reject("É preciso preencher todas as informações do cartão.");
  }
  const tokenInput = document.createElement("input");
  const mp = new MercadoPago(paymentsConfig.getByGateway(20).sdk_public_key, {
    locale: 'pt-BR',
    advancedFraudPrevention: true
  });
  return mp.createCardToken({
    cardNumber,
    cardholderName,
    cardExpirationMonth,
    cardExpirationYear,
    securityCode,
  }).then(result => {
    if (!result || !result.id) {
      throw new Error("Falha ao gerar o token, recarregue a página e tente novamente");
    }
    tokenInput.type = 'hidden';
    tokenInput.name = "token";
    tokenInput.value = result.id;
    form.appendChild(tokenInput);
  });
}
